(ns machtfit.errors
  (:require
   [re-frame.core :as rf]))

(defn capture-with-sentry
  ([type message]
   (capture-with-sentry type message nil))
  ([type message extra-data]
   (capture-with-sentry type message extra-data nil))
  ([type message extra-data tags]
   (when ^boolean js/goog.DEBUG
     (js/console.error message extra-data))
   (if (exists? js/mfSentry)
     (let [error (js/Error message)]
       (set! (.-name error) type)
       (.captureException js/mfSentry error (clj->js (cond-> {:extra extra-data}
                                                       tags (assoc :tags tags)))))
     (js/console.warn "Sentry not loaded. Cannot capture error."))))

(rf/reg-fx ::capture-with-sentry
  (fn [{:keys [type message extra-data tags]}]
    (capture-with-sentry type message extra-data tags)))

(defn capture-message-with-sentry [message extra-data]
  (if (exists? js/mfSentry)
    (do
      (js/console.warn message extra-data)
      (.captureMessage js/mfSentry message (clj->js {:extra extra-data})))
    (js/console.warn "Sentry not loaded. Cannot capture message.")))

(rf/reg-fx ::capture-message-with-sentry
  (fn [{:keys [message extra-data]}]
    (capture-message-with-sentry message extra-data)))
